import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { Button, Glyphicon } from "react-bootstrap";

class Logs extends Component {
	render() {
		return (
			<Button bsStyle="info" {...this.props}>
				<Glyphicon glyph="th-list" /> <span>Logs</span>
			</Button>
		);
	}
}

export default inject("stores")(observer(Logs));



// WEBPACK FOOTER //
// ./src/Core/Components/Buttons/Logs.js